const Medical = () => import(/* webpackChunkName: "pasienmedical" */ '@/views/private/patient/Medical.vue')
const record = () => import(/* webpackChunkName: "pasienmedicalrecord" */ '@/components/medical/Record.vue')
const ANC = () => import(/* webpackChunkName: "pasienmedicalanc" */ '@/components/medical/ANC.vue')
const kesehatan = () => import(/* webpackChunkName: "pasienmedicalkesehatan" */ '@/components/medical/Kesehatan.vue')
const Galery = () => import(/* webpackChunkName: "pasienmedicalgallery" */ '@/components/medical/Galery.vue')
const INC = () => import(/* webpackChunkName: "pasienmedicalinc" */ '@/components/medical/INC.vue')
const Yoga = () => import(/* webpackChunkName: "pasienmedicalyoga" */ '@/components/medical/Yoga.vue')
const Kontrasepsi = () => import(/* webpackChunkName: "pasienmedicalkontrasepsi" */ '@/components/medical/Kontrasepsi.vue')
const Promil = () => import(/* webpackChunkName: "pasienmedicalpromil" */ '@/components/medical/Promil.vue')
const BayiAnak = () => import(/* webpackChunkName: "pasienmedicalbayianak" */ '@/components/medical/BayiAnak.vue')
const Konsultasi = () => import(/* webpackChunkName: "pasienmedicalkonsultasi" */ '@/components/medical/Konsultasi.vue')
const Umum = () => import(/* webpackChunkName: "pasienmedicalumum" */ '@/components/medical/Umum.vue')
const EPINO = () => import(/* webpackChunkName: "pasienmedicalepino" */ '@/components/medical/EPINO.vue')
const Massage = () => import(/* webpackChunkName: "pasienmedicalmassage" */ '@/components/medical/Massage.vue')
const BabyMassageSpa = () => import(/* webpackChunkName: "pasienmedicalbabymassagespa" */ '@/components/medical/BabyMassageSpa.vue')
const LatihanNafas = () => import(/* webpackChunkName: "pasienmedicallatihannafas" */ '@/components/medical/LatihanNafas.vue')
const Hipnoterapi = () => import(/* webpackChunkName: "pasienmedicalhipnoterapi" */ '@/components/medical/Hipnoterapi.vue')
const Akupuntur = () => import(/* webpackChunkName: "pasienmedicalakupuntur" */ '@/components/medical/Akupuntur.vue')
const BirthPlan = () => import(/* webpackChunkName: "pasienmedicalbirthplan" */ '@/components/medical/BirthPlan.vue')
const ReflexBayi = () => import(/* webpackChunkName: "pasienmedicalreflexbayi" */ '@/components/medical/ReflexBayi.vue')
const PNC = () => import(/* webpackChunkName: "pasienmedicalpnc" */ '@/components/medical/PNC.vue')

const routes = [
  {
    path: "/patient/medical",
    name: "patient medical",
    component: Medical,
    meta: {
      title: "Data Pasien"
    },
    children: [
      {
        path: '/patient/medical/record/:id',
        name: ' patient medical record',
        component: record,
        meta: {
          title: "Form Data Riwayat Kunjungan"
        }
      },
      {
        path: '/patient/medical/ANC/:id',
        name: ' patient medical ANC',
        component: ANC,
        meta: {
          title: "Form Data ANC"
        }
      },
      {
        path: '/patient/medical/galery/:id',
        name: ' patient medical galery',
        component: Galery,
        meta: {
          title: "Data Galery Layanan"
        }
      },
      {
        path: '/patient/medical/kesehatan-kehamilan/:id',
        name: ' patient medical kesehatan kehamilan',
        component: kesehatan,
        meta: {
          title: "Data kesehatan & kehamilan"
        }
      },
      {
        path: '/patient/medical/INC/:id',
        name: ' patient medical INC',
        component: INC,
        meta: {
          title: "Form Data INC"
        }
      },
      {
        path: '/patient/medical/Yoga/:id',
        name: ' patient medical Yoga',
        component: Yoga,
        meta: {
          title: "Form Data Yoga"
        }
      },
      {
        path: '/patient/medical/Kontrasepsi/:id',
        name: ' patient medical Kontrasepsi',
        component: Kontrasepsi,
        meta: {
          title: "Form Data Kontrasepsi"
        }
      },
      {
        path: '/patient/medical/Promil/:id',
        name: ' patient medical Promil',
        component: Promil,
        meta: {
          title: "Form Data Promil"
        }
      },
      {
        path: '/patient/medical/Bayi-Anak/:id',
        name: ' patient medical BayiAnak',
        component: BayiAnak,
        meta: {
          title: "Form Data Bayi & Anak"
        }
      },
      {
        path: '/patient/medical/Konsultasi/:id',
        name: ' patient medical Konsultasi',
        component: Konsultasi,
        meta: {
          title: "Form Data Konsultasi"
        }
      },
      {
        path: '/patient/medical/Umum/:id',
        name: ' patient medical Umum',
        component: Umum,
        meta: {
          title: "Form Data Umum"
        }
      },
      {
        path: '/patient/medical/EPINO/:id',
        name: ' patient medical EPINO',
        component: EPINO,
        meta: {
          title: "Form Data EPINO"
        }
      },
      {
        path: '/patient/medical/Massage/:id',
        name: ' patient medical Massage',
        component: Massage,
        meta: {
          title: "Form Data Massage"
        }
      },
      {
        path: '/patient/medical/Baby-Massage-Spa/:id',
        name: ' patient medical BabyMassageSpa',
        component: BabyMassageSpa,
        meta: {
          title: "Form Data Baby Massage Spa"
        }
      },
      {
        path: '/patient/medical/Latihan-Nafas/:id',
        name: ' patient medical LatihanNafas',
        component: LatihanNafas,
        meta: {
          title: "Form Data Latihan Nafas"
        }
      },
      {
        path: '/patient/medical/Hipnoterapi/:id',
        name: ' patient medical Hipnoterapi',
        component: Hipnoterapi,
        meta: {
          title: "Form Data Hipnoterapi"
        }
      },
      {
        path: '/patient/medical/Akupuntur/:id',
        name: ' patient medical Akupuntur',
        component: Akupuntur,
        meta: {
          title: "Form Data Akupuntur"
        }
      },
      {
        path: '/patient/medical/birth-plan/:id',
        name: ' patient medical BirthPlan',
        component: BirthPlan,
        meta: {
          title: "Form Data Birth Plan"
        }
      },
      {
        path: '/patient/medical/reflex-bayi/:id',
        name: ' patient medical ReflexBayi',
        component: ReflexBayi,
        meta: {
          title: "Form Data Reflex Bayi"
        }
      },
      {
        path: '/patient/medical/pnc/:id',
        name: ' patient medical PNC',
        component: PNC,
        meta: {
          title: "Form Data PNC"
        }
      },
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})